import { render, staticRenderFns } from "./assessors.vue?vue&type=template&id=25a7e8a1&"
import script from "./assessors.vue?vue&type=script&lang=js&"
export * from "./assessors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports